import { render, staticRenderFns } from "./profileCategory.vue?vue&type=template&id=89fb641c"
import script from "./profileCategory.vue?vue&type=script&lang=js"
export * from "./profileCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports